import { Mimetypes, mimetypes } from './mimetypes';
import { Customer } from '../app/containers/CustomerSelector/slice/types';

export type ValueOf<T> = T[keyof T];

export type NestedObject<T = {}> = T & {
  [key: string]: NestedObject | string | boolean | number | null | undefined;
};

export interface IFile {
  uuid: string;
  filename: string;
  url?: string;
  size: number;
  mimetype: ValueOf<Mimetypes>;
  extension: string;

  created_at?: string;
  updated_at?: string;
}

export interface IRole {
  id: number | string;
  code: string;
  name: string;

  created_at?: string;
  updated_at?: string;
}
export enum UserPermission {
  VIEW_OWN_DATA = 'view own data',
  VIEW_ALL_DATA = 'view all data',
  ADMINISTER_SYSTEM = 'administer system',
  UPLOAD_DATA = 'upload data',
  CREATE_ADJUSTMENTS = 'create adjustments',
}

export type MfaMethod = 'auth-app' | 'email' | 'sms';

export type IUser = {
  id: number;
  uuid?: string;
  first_name: string;
  last_name: string;
  email: string;
  telephone_mobile: string;

  access_customers: Array<Customer>;
  permissions: Array<UserPermission>;
  pusher?: {
    app_key: string;
    cluster: string;
    tls: boolean;
  };

  is_admin?: boolean;
  enforce_mfa?: boolean;
  show_mfa_nag?: boolean;
  mfa_method?: MfaMethod;
  created_at?: string;
  updated_at?: string;

  days_since_last_password_reset: number;

  email_verification_status: 'unverified' | 'pending' | 'verified';
};
